module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/medicine.json
// module id = 341
// module chunks = 276199462614665